import { createContext, useState, useContext } from 'react';
import { nanoid } from 'nanoid';

const NotificationsContext = createContext();

export const NotificationsProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const addNotification = (header, body, variant) => {
        const newNotification = {
            id: nanoid(),
            header,
            body,
            variant
        }
        setNotifications(prevNotifications => [newNotification, ...prevNotifications]);
    }

    const removeNotification = (id) => {
        setNotifications(prevNotifications => prevNotifications.filter((t) => t.id !== id));
    }

    return (
        <NotificationsContext.Provider value={{ notifications, addNotification, removeNotification }}>
            {children}
        </NotificationsContext.Provider>
    )
}

export const useNotifications = () => useContext(NotificationsContext);
